import { useContext } from 'react';

import type { PageTelemetryContextValue } from '../context';
import { PageTelemetryContext } from '../context';

export const usePageTelemetryContext = (): PageTelemetryContextValue | undefined => useContext(PageTelemetryContext);
